export const routes = {
  home: '/',
  signin: '/signin',
  signout: '/signout',
  users: '/users',
  matches: '/matches',
  prediction: '/prediction',
  predictionResult: '/prediction-result',
  predictionTeam: '/prediction-team',
  topScorer: '/top-scorers',
  predictionTopScorer: '/prediction-top-scorer',
  wc2026Results: '/wc2026-results',
  settings: '/settings',
  whitelist: '/whitelist'
};
